<template>
  <div class="uid-token">
    <div class="uid-token-content">
      <div
        class="input-box"
        v-if="!isJpPlatform || jpUidLogin || isRoleIdLogin"
      >
        <span class="input-label">{{ idLabelText }}</span>
        <input
          v-model="uid"
          class="input"
          type="text"
          inputmode="numeric"
          :placeholder="uidPlaceholderText"
          @compositionstart="onUidCompositionStart"
          @compositionend="onUidCompositionEnd"
          @input="onUidInput"
          @focus="initViewport"
          :disabled="isPopupMode"
        />
        <em
          class="switch-btn"
          @click="switchLoginType"
          v-if="isJpPlatform"
        ></em>
      </div>
      <div class="input-box" v-if="!isJpPlatform || isJpUidTokenLogin">
        <span class="input-label">{{
          isJpPlatform ? 'LoginPass:' : 'OTP:'
        }}</span>
        <input
          v-model="dynamicCode"
          :placeholder="
            isJpPlatform ? letter.jpUidInputToken : letter.uidInputToken
          "
          class="input"
          type="number"
        />
      </div>
      <div class="input-box verification" v-if="needVerticationCode">
        <input
          v-model="verificationCode"
          class="input verification"
          :placeholder="letter.uidInputCode"
          @focus="initViewport"
        />
        <img
          class="verification-img"
          :src="verificationImgSrc"
          alt="verificationImg"
          @click="refreshVerificationImg"
        />
      </div>
      <div
        class="uid-token-login-btn j-uid-token-login-btn"
        @click="newUidTokenLogin"
      >
        {{ letter.login }}
      </div>
    </div>
  </div>
</template>

<script type="text/javascript">
import { mapGetters, mapState } from 'vuex';
import globalConfig from '@utiles/officialStore/globalConfig';
import {
  SWITCH_SERVER,
  UPDATE_PC_SERVER_ID,
  UPDATE_ROLE_LIST,
  GET_SERVER_LIST,
  UPDATE_LOADING,
  GET_ROLE_LIST,
  UPDATE_PRODUCT_LIST,
  UPDATE_PRODUCT_TYPES,
  UPDATE_ROLE_NAME,
  SWITCH_ROLE
} from '@store/officialTopup';
import {
  UID_LOGIN,
  GO_UID_TOKEN_LOGIN,
  CHECK_NEED_VERIFICATION_CODE,
  ROLE_ID_LOGIN
} from '@store/officialTopup/login';
import { GET_JPSTORE_TOKEN_LOGIN_BY_UID } from '@store/officialTopup/jp';
import { initViewport } from '@utiles/officialStore/index';
import { locationType, clickButton } from '@plugins/biPoint/_configWebstoreV3';
import { mapServerIdBypcServerId } from '@mixins/officialTopup/login';
import uidNumericInput from '@mixins/uidNumericInput';
const mainHost = globalConfig.getMainHost();

export default {
  name: 'uidTokenLogin',
  mixins: [uidNumericInput],
  props: {
    // 是否是弹窗模式 {
    isPopupMode: {
      type: Boolean,
      default: false
    },
    // 弹窗模式自定义标题
    popupModeTitle: {
      type: String,
      default: ''
    },
    defaultUid: {
      type: String,
      default: ''
    },
    // 是否需要UID输入
    needInputUid: {
      type: Boolean,
      default: true
    },
    // 是否是日本江美UidToken登录
    isJpUidTokenLogin: {
      type: Boolean,
      default: false
    },
    // 需要的动态令牌数字数量
    uidNum: {
      type: Number,
      default: 4,
      validator: value => {
        return typeof value === 'number' && value >= 4;
      }
    },
    isRoleIdLogin: {
      type: Boolean,
      default: false
    },
    jpUidLogin: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      uid: '',
      dynamicCode: '',
      verificationCode: '',
      verificationImgSrc: `//gpassport.${mainHost}/center/ajax/get_code`,
      canUidTokenLogin: true,
      showGuide: false,
      loading: false,
      needVerticationCode: false
    };
  },
  computed: {
    ...mapGetters(['isJpPlatform']),
    ...mapState({
      roleList: state => state.roleList
    }),
    lang() {
      return this.$store.state.lang;
    },
    gameId() {
      return this.$store.state.gameId;
    },
    letter() {
      return this.$store.state.letter;
    },
    uidPlaceholderText() {
      if (this.isJpPlatform) {
        return this.isRoleIdLogin
          ? 'キャラクターIDを入力してください'
          : 'UIDを入力してください';
      }
      return this.letter.uidInputUid;
    },
    idLabelText() {
      if (this.isJpPlatform) {
        return this.isRoleIdLogin ? 'キャラクターID:' : 'ユーザーセンターID:';
      }
      return 'UID:';
    }
  },
  created() {
    if (this.isPopupMode) {
      this.uid = this.defaultUid;
    }
    if (this.isJpPlatform) {
      return;
    }
    this.checkNeedVerificationCode();
  },
  methods: {
    refreshVerificationImg() {
      this.verificationImgSrc = `//gpassport.${mainHost}/center/ajax/get_code?${this.randomNumber(
        1,
        100000
      )}`;
      this.verificationCode = '';
    },
    checkInputValid() {
      if (
        (!this.isJpPlatform || this.jpUidLogin) &&
        this.needInputUid &&
        !this.uid
      ) {
        alert(this.letter.uidInputUid);
        return false;
      }

      if (!this.dynamicCode) {
        alert(this.letter.uidInputToken);
        return false;
      }

      if (!this.verificationCode && this.needVerticationCode) {
        alert(this.letter.uidInputCode);
        return false;
      }

      return true;
    },
    resetDynamicCodeInput() {
      this.dynamicCode = '';
    },
    doUidLogin() {
      if (!this.uid) {
        alert(
          this.jpUidLogin ? 'UIDを入力してください' : this.letter.storeInputId
        );
        return;
      }
      this.loading = true;
      this.$store.commit(UPDATE_LOADING, true);
      this.$store
        .dispatch(UID_LOGIN, {
          uid: this.uid,
          gameId: this.gameId,
          language: this.lang
        })
        .then(res => {
          if (+res?.result) {
            this.tokenLoginSuccessHandle();
          } else {
            this.tokenLoginFailHandle(res);
          }
        })
        .catch(({ msg }) => {
          this.loading = false;
          this.$store.commit(UPDATE_LOADING, false);
          this.$store.commit(SWITCH_SERVER, 0);
          this.$store.commit(UPDATE_PC_SERVER_ID, 0);
          this.$store.commit(UPDATE_ROLE_LIST, []);
          alert(msg);
        });
    },
    // 兼容全球和日本平台三种登录方式处理(uid登录、token登录、uid+token登录)
    newUidTokenLogin() {
      // 2015.3.12 江美角色id登录
      if (this.isJpPlatform && this.isRoleIdLogin) {
        this.roleIdLogin();
        return;
      }
      // 2024.9.9 日本江美改版v2处理 全球平台uid+token登录 或 日本平台且非uid登录 或 日本平台uid+token登录
      if (!this.isJpPlatform || !this.jpUidLogin || this.isJpUidTokenLogin) {
        this.uidTokenLogin();
      } else {
        this.doUidLogin();
      }
    },
    // 2015.3.12 江美角色id登录
    roleIdLogin() {
      clickButton({
        btnName: 'role_id_login_confirm',
        locationKey: locationType.loginPopup
      });
      if (!this.uid) {
        alert('キャラクターIDを入力してください');
        return;
      }
      if (!this.canUidTokenLogin) {
        return;
      }
      this.canUidTokenLogin = false;
      this.loading = true;
      this.$store.commit(UPDATE_LOADING, true);
      this.$store
        .dispatch(ROLE_ID_LOGIN, {
          role_id: this.uid,
          game_id: this.$store.state.gameId,
          packageName: globalConfig.getHrefParam('packageName')
        })
        .then(res => {
          res?.result
            ? this.roleIdLoginSuccessHandle(res.data)
            : this.tokenLoginFailHandle(res);
        });
    },
    // 全球和日本令牌登录总入口
    uidTokenLogin() {
      clickButton({
        btnName: 'uid_token_login_confirm',
        locationKey: locationType.loginPopup
      });
      if (!this.checkInputValid()) {
        return;
      }
      if (!this.canUidTokenLogin) {
        return;
      }
      this.canUidTokenLogin = false;
      this.loading = true;
      this.$store.commit(UPDATE_LOADING, true);
      this.isJpPlatform ? this.jpUidTokenLogin() : this.globalUidTokenLogin();
    },
    getCurRoleName(id) {
      let res = '';
      if (!this.roleList) return res;
      for (let i in this.roleList) {
        if (this.roleList[i].roleID == id) {
          res = this.roleList[i].roleName;
          break;
        }
      }
      return res;
    },
    roleIdLoginSuccessHandle(data) {
      const pcServerId = data?.SERVER_ID || 0;
      const roleId = data?.ROLE_ID || 0;
      if (pcServerId && roleId) {
        let serverId = '';
        this.$store.dispatch(GET_SERVER_LIST).then(async serverList => {
          serverId = mapServerIdBypcServerId(pcServerId, serverList.history); // 先匹配历史选择过的服务器
          if (!serverId) {
            serverId = mapServerIdBypcServerId(pcServerId, serverList.all); // 历史中选择过的服务器没有找到才全部搜一遍
          }
          if (serverId) {
            this.$store.commit(SWITCH_SERVER, serverId);
            this.$store.commit(UPDATE_PC_SERVER_ID, pcServerId);
            this.$store.commit(SWITCH_ROLE, roleId);
            await this.$store.dispatch(GET_ROLE_LIST, serverId);
            this.$store.commit(UPDATE_ROLE_NAME, this.getCurRoleName(roleId));
            this.$store.commit(UPDATE_PRODUCT_LIST, []);
            this.$store.commit(UPDATE_PRODUCT_TYPES, []);
          }
          this.$store.commit(UPDATE_LOADING, false);
        });
      }
      this.$store.commit(UPDATE_LOADING, false);
      this.loading = false;
    },
    // 全球和日本令牌登录成功公共逻辑
    tokenLoginSuccessHandle() {
      if (this.isPopupMode) {
        this.$store.commit(UPDATE_LOADING, false);
        this.$emit('loginSuccess');
      } else {
        this.$store.commit(SWITCH_SERVER, 0);
        this.$store.commit(UPDATE_PC_SERVER_ID, 0);
        this.$store.commit(UPDATE_ROLE_LIST, []);
        this.$store.dispatch(GET_SERVER_LIST).then(_serverList => {
          this.$store.commit(UPDATE_LOADING, false);
        });
      }
      this.loading = false;
    },
    // 全球和日本令牌登录失败公共逻辑
    tokenLoginFailHandle(res) {
      this.loading = false;
      this.$store.commit(UPDATE_LOADING, false);
      this.canUidTokenLogin = true;
      this.resetDynamicCodeInput();
      alert(res.msg);
    },
    // 全球平台令牌登录
    globalUidTokenLogin() {
      this.$store
        .dispatch(GO_UID_TOKEN_LOGIN, {
          uid: this.uid,
          token: this.dynamicCode,
          ckcode: this.verificationCode,
          gameId: this.$store.state.gameId,
          packageName: globalConfig.getHrefParam('packageName')
        })
        .then(res => {
          if (res?.result) {
            this.tokenLoginSuccessHandle();
          } else {
            this.checkNeedVerificationCode();
            this.tokenLoginFailHandle(res);
          }
        });
    },
    // 日本平台令牌登录
    jpUidTokenLogin() {
      let actionName = '';
      let params = {
        token: this.dynamicCode,
        gameId: this.$store.state.gameId
      };
      if (this.isPopupMode) {
        actionName = GET_JPSTORE_TOKEN_LOGIN_BY_UID;
        Object.assign(params, {
          uid: this.$store.state.login.uid
        });
      } else {
        actionName = GO_UID_TOKEN_LOGIN;
      }
      this.$store.dispatch(actionName, params).then(res => {
        res?.result
          ? this.tokenLoginSuccessHandle()
          : this.tokenLoginFailHandle(res);
      });
    },
    // 判断是否需要输入验证码
    checkNeedVerificationCode() {
      this.$store.dispatch(CHECK_NEED_VERIFICATION_CODE).then(res => {
        if (res?.result) {
          if (res.data && +res.data.NEED_CKCODE === 1) {
            this.needVerticationCode = true;
            this.refreshVerificationImg();
          } else {
            this.needVerticationCode = false;
          }
        } else {
          alert(res?.msg);
        }
      });
    },
    randomNumber(min, max) {
      const randomBuffer = new Uint32Array(1);
      window.crypto.getRandomValues(randomBuffer);
      const number = randomBuffer[0] / (0xffffffff + 1);
      return Math.floor(number * (max - min) + min);
    },
    switchLoginType() {
      this.$emit(
        'setLoginTypeTrue',
        this.isRoleIdLogin ? 'jpUidLogin' : 'isRoleIdLogin'
      );
    },
    initViewport
  }
};
</script>

<style lang="scss" scoped>
@import '@assets/scss/officialTopup/officialTopup.scss';
.uid-token {
  padding: 0 40px;
  font-size: 22px;
  color: #333;
  &-content {
    width: 603px;
  }
  .input-box {
    height: 80px;
    display: flex;
    align-items: center;
    padding: 0 20px;
    border-radius: 6px;
    border: solid 1px #e8e8e8;
    margin-bottom: 20px;

    .input-label {
      font-size: 20px;
      color: #999999;
      margin-right: 10px;
    }

    &.verification {
      border-bottom: none;
    }

    .input {
      flex: 1;
      font-size: 24px;
      &.verification {
        width: 360px;
        border: 1px solid #d2d2d2;
        padding: 0 20px;
        height: 100%;
        border-radius: 10px;
        box-sizing: border-box;
      }
    }
    .iconfont {
      position: absolute;
      right: 0;
      font-size: 32px;
      color: $themeColor;
      cursor: pointer;
    }
    .verification-img {
      width: 234px;
      height: 100%;
      margin-left: 9px;
      border-radius: 10px;
    }
    .switch-btn {
      display: block;
      width: 38px;
      height: 38px;
      background: url($commonImg + 'switch-btn.png') no-repeat;
      background-size: cover;
      cursor: pointer;
    }
  }

  &-login-btn {
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 30px auto;
    line-height: 80px;
    height: 80px;
    font-size: 24px;
    color: #fff;
    background: $themeColor;
    border-radius: 6px;
    cursor: pointer;
  }
}
</style>
